import script from "./AddGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddGroup.vue?vue&type=script&setup=true&lang=ts"

import "./AddGroup.vue?vue&type=style&index=0&id=0d69ee75&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d69ee75"]])

export default __exports__